"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChecklist = void 0;
const react_1 = require("react");
const notifyParent = (parent) => (message) => {
    window.parent.postMessage(message, parent);
};
const YOUTUBE_LINK = 'https://youtu.be/Ujvy-DEA-UM';
// We have to keep this task list up-to-date with the website's checklist
const [REACT_TO_MESSAGE, RUN_GIPHY, SEND_YOUTUBE, DRAG_DROP, START_THREAD, SEND_MESSAGE] = [
    'react-to-message',
    'run-giphy',
    'send-youtube',
    'drag-drop-image',
    'start-thread',
    'send-message',
];
const useChecklist = (props) => {
    const { chatClient, targetOrigin } = props;
    (0, react_1.useEffect)(() => {
        if (!targetOrigin)
            return;
        const notify = notifyParent(targetOrigin);
        const handleNewEvent = (props) => {
            var _a;
            const { message, type } = props;
            switch (type) {
                case 'reaction.new':
                    notify(REACT_TO_MESSAGE);
                    break;
                case 'message.new':
                    if ((message === null || message === void 0 ? void 0 : message.command) === 'giphy') {
                        notify(RUN_GIPHY);
                        break;
                    }
                    if ((_a = message === null || message === void 0 ? void 0 : message.attachments) === null || _a === void 0 ? void 0 : _a.length) {
                        if (message.attachments[0].type === 'video' &&
                            message.attachments[0].og_scrape_url === YOUTUBE_LINK) {
                            notify(SEND_YOUTUBE);
                            break;
                        }
                        if (message.attachments[0].type === 'image') {
                            notify(DRAG_DROP);
                            break;
                        }
                    }
                    if (message === null || message === void 0 ? void 0 : message.parent_id) {
                        notify(START_THREAD);
                        break;
                    }
                    notify(SEND_MESSAGE);
                    break;
                default:
                    break;
            }
        };
        if (chatClient) {
            chatClient.on(handleNewEvent);
        }
        return () => chatClient === null || chatClient === void 0 ? void 0 : chatClient.off(handleNewEvent);
    }, [chatClient, targetOrigin]);
};
exports.useChecklist = useChecklist;
